export default __webpack_public_path__ + "static/media/calendar-purple.f6f60d30.svg";